export const SITEWIDE_WIDGET_SELECTION = 'SITEWIDE_WIDGET_SELECTION';
